var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lables"},_vm._l((_vm.tabArr),function(item,idx){return _c('span',{key:idx,class:item.value===_vm.activeVal?'active':'',on:{"click":function($event){return _vm.lableChange(item.value)}}},[_vm._v(_vm._s(item.lable))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }